module.exports = __webpack_public_path__ + "img/iconull2.87c05b59.png";